import { geneticsBasicsModule } from "./basics";
import { geneticsMethodsModule } from "./methods";
import { chromosomeDefectsModule } from "./chromosomeDefects";
import { chromosomeDefects2Module } from "./chromosomeDefects2";
import { chromosomeDefects3Module } from "./chromosomeDefects3";
import { biochemicalDisordersModule } from "./biochemicalDisorders";
import { repeatDisordersModule } from "./repeatDisorders";

export const geneticsModules = [
  geneticsBasicsModule,
  geneticsMethodsModule,
  chromosomeDefectsModule,
  chromosomeDefects2Module,
  chromosomeDefects3Module,
  biochemicalDisordersModule,
  repeatDisordersModule,
];
